import officeStandard from '@/assets/img/users-cases/office-standard.webp';
import officeStandardHow from '@/assets/img/users-cases/office-standard-how.webp';
import officeStandardResult from '@/assets/img/users-cases/office-standard-result.webp';

export default {
  slug: '3D-tour-office',
  order: 1,
  title: '3D Tour Office',
  subtitle: '2D and 3D renderings for practical office layouts',
  tags: ['Officefloorplans', 'Officelayouts'],

  images: {
    hero: officeStandard,
    aboutTop: officeStandardHow,
    aboutBottom: officeStandardResult,
  },

  howText:
    'We created office floor plan and layouts for offices, including options like open-space, private offices, co-working, and executive suites. Each plan includes 2D office floor plan and 3D office floor plan, along with office interior design and interior design for offices with furniture, lighting, and materials selection.',

  resultText:
    'Ready 2D and 3D office plans allow developers and marketing agencies to present spaces to clients, prepare marketing materials, and speed up approval processes with investors.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: ['office-dark', 'office-elegance'],
};
